import React from "react";
import Button from "../../VibehutUI/Button";
import DoubleStar from "../../VibehutUI/Icons/DoubleStar";
interface Props {
  setIsSearchOpen: (open: boolean) => {};
}
export const InterestedEventcard = ({ setIsSearchOpen }: Props) => {
  return (
    <div className="flex  flex-row sm:flex-col md:flex-row items-center sm:items-start md:items-center justify-between gap-2.5 bg-frescoWhite px-2 py-3 rounded-2xl">
      <div className="flex items-center justify-between w-full ">
        <main className="flex  items-center gap-3">
          <div className="w-7 h-7 rounded-full flex justify-center items-center bg-primary text-white">
            <DoubleStar />
          </div>
          <div className="flex flex-col">
            <span className="text-darkNight font-medium text-sm">
              Share Your Availability
            </span>
            <span className="text-darkGray text-xs">
              Click to view available slots
            </span>
          </div>
        </main>
        <div className="flex items-center">
          <Button
            customClasses="px-4 py-2"
            size="vibhut-sm"
            variant="vibhut-primary"
            onClick={() => {
              setIsSearchOpen(true);
            }}
          >
            See Times
          </Button>
        </div>
      </div>
    </div>
  );
};
